// ✅ CRITICAL FIX: Load Lodash SYNCHRONOUSLY before any other imports
import _ from 'lodash'
// Assign immediately and ensure it's available
window._ = _
// Force synchronous assignment with error checking
if (!window._) {
  console.error('❌ Failed to load lodash globally')
} else {
  console.log('✅ Lodash loaded globally as window._')
}

// ✅ CRITICAL FIX: Create missing window.config system for theme management
const phoenixConfig = {
  // Default theme configuration matching Phoenix theme expectations
  phoenixTheme: 'light',
  phoenixNavbarTopShape: 'default',
  phoenixNavbarTopStyle: 'default',
  phoenixNavbarPosition: 'vertical',
  phoenixNavbarVerticalStyle: 'default',
  phoenixIsRTL: false,
  phoenixSupportChat: false
}

// Load existing values from localStorage
Object.keys(phoenixConfig).forEach(key => {
  const stored = localStorage.getItem(key)
  if (stored !== null) {
    try {
      // Try parsing as JSON first (for booleans)
      phoenixConfig[key] = JSON.parse(stored)
    } catch {
      // Fallback to string value
      phoenixConfig[key] = stored
    }
  }
})

// Create window.config with expected interface
window.config = {
  config: phoenixConfig,

  set(updates) {
    Object.entries(updates).forEach(([key, value]) => {
      // Update in-memory config
      this.config[key] = value
      // Persist to localStorage
      localStorage.setItem(key, JSON.stringify(value))
    })
    console.log('📝 Config updated:', updates)
  },

  reset() {
    // Clear all phoenix config from localStorage
    Object.keys(phoenixConfig).forEach(key => {
      localStorage.removeItem(key)
    })
    // Reset to defaults
    Object.assign(this.config, phoenixConfig)
    console.log('🔄 Config reset to defaults')
  }
}

console.log('✅ window.config system initialized:', window.config.config)

// Add diagnostic logging after page loads
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const diagnostics = {
      lodash: !!window._,
      config: !!window.config,
      googleMaps: !!(window.google?.maps),
      controllers: document.querySelectorAll('[data-controller]').length,
      timestamp: new Date().toISOString()
    }
    console.log('🏥 System Health Check:', diagnostics)

    // Alert if critical systems missing
    if (!window._ || !window.config) {
      console.error('🚨 CRITICAL: Core systems missing - potential black screen risk!')
    }
  }, 2000) // Check after 2 seconds to allow everything to load
})

import "@hotwired/turbo-rails"
import "../controllers"

// Disable Turbo caching in development to prevent stale content issues
if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
  // Disable Turbo's visit cache (page cache)
  import("@hotwired/turbo").then((Turbo) => {
    if (Turbo.cache) {
      Turbo.cache.exemptPageFromCache()
    }
  })

  // Clear Turbo cache on page load
  document.addEventListener("turbo:load", () => {
    // Force reload all turbo frames to prevent cached content
    document.querySelectorAll('turbo-frame[src]').forEach(frame => {
      if (frame.src && frame.loaded) {
        frame.reload()
      }
    })
  })

  // Add cache-busting headers to all Turbo requests
  document.addEventListener("turbo:before-fetch-request", (event) => {
    event.detail.fetchOptions.headers = event.detail.fetchOptions.headers || {}
    event.detail.fetchOptions.headers["Cache-Control"] = "no-cache, no-store, must-revalidate"
    event.detail.fetchOptions.headers["Pragma"] = "no-cache"
  })
}

// A tab's panel is a lazy turbo-frame. When the server answers it with a redirect to a full page (a signed-in user who has not finished
// onboarding is sent to /onboarding), that page has no matching frame and Turbo prints "Content missing". Visit the page properly instead.
document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault()
  event.detail.visit(event.detail.response)
})

// Configure CSRF tokens for Turbo forms
document.addEventListener("turbo:before-fetch-request", (event) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
  if (token) {
    event.detail.fetchOptions.headers = event.detail.fetchOptions.headers || {}
    event.detail.fetchOptions.headers["X-CSRF-Token"] = token
  }
})

// Phoenix Theme JavaScript
import "../theme/js/phoenix"; // Main Phoenix theme JS
import "../theme/js/utils"; // Phoenix utilities

// Optional: Add other Phoenix JS modules as needed
// import "../theme/js/config"; // Theme configuration 